// extracted by mini-css-extract-plugin
module.exports = {"comp":"Users_comp__pIODt"};